import { useTranslation } from 'react-i18next';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { CarrierLink, CarrierPhoneText } from '../CarrierInformation.styles';

interface CarrierPhoneNumberProps {
  phone: string;
}

export const CarrierPhoneNumber = ({
  phone,
}: CarrierPhoneNumberProps): JSX.Element => {
  const { t } = useTranslation();
  const { isDesktop } = useDetectDevice();

  if (isDesktop) {
    return (
      <CarrierPhoneText id="carrier-phone" aria-label={phone}>
        {phone}
      </CarrierPhoneText>
    );
  }

  return (
    <CarrierLink
      url={`tel: ${phone}`}
      type="phone"
      id="carrier-phone"
      ariaLabel={`${t('PTP_ALT_TEXT_PHONE')} ${phone}`}
    >
      {phone}
    </CarrierLink>
  );
};
